module.exports = require('./sri-client-error.js');


// WEBPACK FOOTER //
// ./node_modules/@kathondvla/curriculum-manager/node_modules/@kathondvla/sri-client/sri-client-error/index.js